export default __webpack_public_path__ + "images/5f5290a5fc1a84613787dd5a71decccc.svg";